/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  margin-bottom: 30px;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #c9cbd3;
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 246px;
  height: 45px;
  background: ${({ selected }) =>
    selected ? '#fff 0% 0% no-repeat padding-box' : '#c9cbd3 0% 0% no-repeat padding-box'};
  color: ${({ selected }) => (selected ? '#1C1B3A' : ' #fff')};
  border-radius: 4px 4px 0px 0px;
  border: 0.5px solid #c9cbd3;
  border-bottom: 0px;
  font: normal normal normal 20px/30px Biotif;
`;

export const TabTitle = styled.div`
  font: normal normal normal 16px/24px Biotif;
  text-transform: capitalize;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  height: 80vh;
  align-items: flex-start;

  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FeatureToggleLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  padding: 30px;
  width: 100%;
  border-bottom: 1px solid #f3f4f8;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  background-color: #fff;
  height: 80vh;
`;
